import React, { useState, useEffect } from "react";
import { Table, Pagination } from "antd";
import { fetchStatuses } from "../utils/fetch";
import {
  getOrderStatusDataSource,
  orderStatusColumnsNew,
} from "../utils/table";
import OrderStatusFullInfo from "./OrderStatusFullInfo";

const NewStatus = ({ query = "", userPermission }) => {
  const [leads, setLeads] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  // Функция для загрузки данных
  const loadData = async (page = 1, pageSize = 20) => {
    try {
      setIsLoading(true);
      // Передаём pageSize и page согласно порядку параметров:
      // fetchStatuses(state, status, query, setSpecifications, setIsLoading, setTotalPage, size, page, remaining, excludeStatus)
      const res = await fetchStatuses("NEW", "REVIEW", query, setLeads, setIsLoading, setTotalCount, pageSize, page);
      // Ожидаем, что API возвращает:
      // data.data.application -> массив заявок,
      // data.data.currentPage  -> номер текущей страницы,
      // data.data.totalCount   -> общее число записей
      setLeads(res.data.application || []);
      setCurrentPage(res.data.currentPage || page);
      setLimit(pageSize);
      setTotalCount(res.data.totalCount || 0);
    } catch (err) {
      console.error("Error fetching NewStatus:", err);
    } finally {
      setIsLoading(false);
    }
  };

  // Загружаем данные при первом рендере и при изменении query
  useEffect(() => {
    loadData(currentPage, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  // Обработчик смены страницы и изменения размера страницы
  const handlePageChange = (page, pageSize) => {
    loadData(page, pageSize);
  };

  return (
    <div>
      <Table
        style={{ minWidth: 1000 }}
        size="small"
        bordered
        loading={isLoading}
        dataSource={getOrderStatusDataSource(leads)}
        columns={orderStatusColumnsNew}
        pagination={false}
        expandable={{
          expandedRowRender: (record) => (
            <OrderStatusFullInfo data={record.data} userPermission={userPermission} />
          ),
        }}
      />
      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Pagination
          current={currentPage}
          total={totalCount}
          pageSize={limit}
          onChange={handlePageChange}
          showSizeChanger
          onShowSizeChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default NewStatus;
